(function () {
  'use strict';

  // Defensive: strip ?access_token=... from URL if Outseta ever leaks it on
  // a redirect. The cookie is the source of truth; the URL token is noise +
  // a privacy/security risk in browser history & server logs.
  (function stripLeakedToken(){
    if (window.location.search.indexOf('access_token=') === -1) return;
    var clean = window.location.pathname +
      window.location.search.replace(/[?&]access_token=[^&]*/g, '').replace(/^\?$/, '') +
      window.location.hash;
    try { window.history.replaceState(null, '', clean); } catch (e) {}
  })();

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function decodeJwt(t) {
    try {
      var parts = t.split('.');
      if (parts.length < 2) return null;
      var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4) b64 += '=';
      var json = decodeURIComponent(atob(b64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(json);
    } catch (e) { return null; }
  }

  function deviceLabel() {
    var ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    if (/Android/i.test(ua)) return 'Android';
    return 'desktop';
  }

  function showDiag() {
    var existing = document.getElementById('bh-diag-modal');
    if (existing) { existing.remove(); return; }
    var s = window.__bhState || {};
    var stageLabel = s.loggedIn === false ? 'anonymous'
      : s.stage === 2 ? 'trialing'
      : s.stage === 3 ? 'subscribing'
      : (s.stage != null && s.stage >= 4) ? 'expired'
      : s.loggedIn ? 'logged-in (stage unknown)'
      : '(not yet resolved)';
    var inApp = !!(window.ReactNativeWebView && window.ReactNativeWebView.postMessage);
    var ua = navigator.userAgent || '';
    var bhAppMatch = ua.match(/BrightHavenApp\/([^\s]+)/);
    var token = getCookie('Outseta.nocode.accessToken');
    var jwt = token ? decodeJwt(token) : null;
    var jwtSummary = jwt ? { sub: jwt.sub, email: jwt.email, planUid: jwt['outseta:planUid'], subUid: jwt['outseta:subscriptionUid'], exp: new Date(jwt.exp * 1000).toISOString() } : null;
    var action = window.__bhAction || null;
    var rows = [
      ['Page', window.location.pathname + window.location.search],
      ['Device', deviceLabel()],
      ['In-App', inApp ? ('YES (' + (bhAppMatch ? bhAppMatch[1] : 'unknown ver') + ')') : 'no'],
      ['Auth state', stageLabel],
      ['Outseta cookie', token ? 'present' : 'NONE'],
      ['Return-to (sessionStorage)', sessionStorage.getItem('bh_return_to') || '(none)']
    ];
    if (window.BH_V2_BRIDGE) {
      rows.push(['Magnet book', window.BH_V2_BRIDGE.isMagnet ? 'yes' : 'no']);
      rows.push(['Page ID', window.BH_V2_BRIDGE.bhPageId]);
    }
    if (action) {
      rows.push(['Active format', action.format]);
      rows.push(['Action type', action.type]);
      rows.push(['Book ID', action.bookId]);
      rows.push(['UL target', action.url]);
    }
    var html = '<div style="position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;">' +
      '<div style="position:absolute;inset:0;background:rgba(0,0,0,0.6);" onclick="document.getElementById(\'bh-diag-modal\').remove()"></div>' +
      '<div style="position:relative;background:#fff;border-radius:10px;padding:1.25rem;max-width:560px;width:90%;max-height:80vh;overflow:auto;font-family:system-ui,-apple-system,sans-serif;color:#111;">' +
      '<button style="position:absolute;top:0.5rem;right:0.75rem;background:transparent;border:none;font-size:1.5rem;cursor:pointer;" onclick="document.getElementById(\'bh-diag-modal\').remove()">&times;</button>' +
      '<h3 style="margin:0 0 0.75rem;font-size:1.1rem;">v2 lane diagnostics</h3>' +
      '<table style="width:100%;border-collapse:collapse;font-size:0.85rem;font-family:ui-monospace,Menlo,monospace;">';
    for (var r = 0; r < rows.length; r++) {
      html += '<tr><td style="padding:4px 8px;border-bottom:1px solid #eee;color:#666;white-space:nowrap;">' + rows[r][0] + '</td><td style="padding:4px 8px;border-bottom:1px solid #eee;word-break:break-all;">' + (rows[r][1] == null ? '' : String(rows[r][1])) + '</td></tr>';
    }
    html += '</table>';
    if (jwtSummary) {
      html += '<details style="margin-top:0.75rem;font-size:0.8rem;"><summary style="cursor:pointer;">JWT claims</summary><pre style="background:#f7f7f7;padding:8px;border-radius:6px;overflow:auto;">' + JSON.stringify(jwtSummary, null, 2) + '</pre></details>';
    }
    html += '</div></div>';
    var wrap = document.createElement('div');
    wrap.id = 'bh-diag-modal';
    wrap.innerHTML = html;
    document.body.appendChild(wrap);
  }

  function mountButton() {
    if (document.getElementById('bh-diag-btn')) return;
    var diagBtn = document.createElement('button');
    diagBtn.id = 'bh-diag-btn';
    diagBtn.textContent = '🔍 v2 diag';
    diagBtn.style.cssText = 'position:fixed;bottom:1rem;left:1rem;z-index:9998;background:#1f1f1f;color:#fff;border:none;border-radius:999px;padding:0.5rem 0.85rem;font-size:0.85rem;cursor:pointer;box-shadow:0 4px 12px rgba(0,0,0,0.2);';
    diagBtn.addEventListener('click', showDiag);
    document.body.appendChild(diagBtn);
  }

  if (window.location.search.indexOf('bh_diag=1') >= 0) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountButton);
    } else {
      mountButton();
    }
  }

  // Header-menu URL rewriter: while we're on a v2 page, rewrite clicks on
  // bare /pages/{plans,account-information,upgrade-your-plan} so navigation
  // stays in the v2 lane. Skip if the link already has any ?view= param.
  var V2_MAP = {
    '/pages/plans': 'plans-v2',
    '/pages/account-information': 'signin-v2',
    '/pages/upgrade-your-plan': 'upgrade-v2'
  };
  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el.tagName !== 'A') el = el.parentElement;
    if (!el || !el.href) return;
    var u;
    try { u = new URL(el.href, window.location.href); } catch (err) { return; }
    if (u.hostname !== window.location.hostname) return;
    if (u.searchParams.has('view')) return;
    var view = V2_MAP[u.pathname];
    if (!view) return;
    u.searchParams.set('view', view);
    el.href = u.toString();
  }, true);
})();

